import { render } from "./PlanShipmentImportSettings.vue?vue&type=template&id=93afc27a&scoped=true&ts=true"
import script from "./PlanShipmentImportSettings.vue?vue&type=script&lang=ts"
export * from "./PlanShipmentImportSettings.vue?vue&type=script&lang=ts"

import "./PlanShipmentImportSettings.vue?vue&type=style&index=0&id=93afc27a&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93afc27a"]])

export default __exports__